import { defineComponent } from 'vue';
export default defineComponent({
  name: 'mobileView',
  setup(props) {
    return {};
  }
});